import { render, staticRenderFns } from "./createuser2.vue?vue&type=template&id=cb80526a"
import script from "./createuser2.vue?vue&type=script&lang=js"
export * from "./createuser2.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports